export default (date: Date): Date => {
  return new Date(
    Date.UTC(new Date(date).getFullYear(), new Date(date).getMonth(), new Date(date).getDate()),
  );
};
